<template>
  <div class="introduction bg-light" style="background-image: linear-gradient(-180deg, #f7faff,#eee);">
    <!-- Hero Section -->
    <div id="SVGheroSectionBg" class="svg-preloader position-relative">
      <div class="container space-2">
        <div class="row aalign-items-lg-center">
          <div class="col-lg-5 mb-7 mb-lg-0">
            <!-- Info -->
            <h1 class="mb-4">We find the <span class="text-primary font-weight-semi-bold">best mortgage deals</span> for you!</h1>
            <p>By talking to all major UK mortgage lenders and matching their products to your unique requirements.</p>
            <button class="btn btn-success w-100 mt-2" @click="$emit('cta')">Let's get started...</button>
            <!-- End Info -->
          </div>
          <div class="col-lg-7">
            <!-- SVG Icon -->
            <figure class="ie-working-men">
              <img class="js-svg-injector" src="/assets/svg/illustrations/knowledgebase-community-1.svg" alt="Image Description"
                   data-parent="#SVGheroSectionBg">
            </figure>
            <!-- End SVG Icon -->
          </div>
        </div>
      </div>
      <!-- SVG Background -->
      <figure class="position-absolute right-0 bottom-0 left-0">
        <img class="js-svg-injector" style="width: 100%; height: 128px"  src="/assets/svg/components/wave-4-bottom.svg" alt="Image Description"
             data-parent="#SVGheroSectionBg">
      </figure>
      <!-- End SVG Background Section -->
    </div>
    <!-- End Hero Section -->
  </div>
</template>

<script>
export default {
  name: "GettingStartedBanner"
};
</script>
